webpackJsonp([76],{

/***/ 1372:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1373);


/***/ }),

/***/ 1373:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(212);

var _datetime2 = _interopRequireDefault(_datetime);

var _en = __webpack_require__(849);

var _en2 = _interopRequireDefault(_en);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('en', _en2.default);

/***/ })

},[1372]);


// WEBPACK FOOTER //
// app/datetime.en-d52c0efff19ac9cba00e.js